import {
  Box,
  Button,
  Flex,
  Image,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { ModalVisualizarCanhoto } from './ModalVisualizarCanhoto'

export function Card({ pedido }) {
  return (
    <Box
      bg="white"
      borderRadius="md"
      p={4}
      boxShadow="md"
      display="flex"
      gap={4}
      maxW="fit-content"
    >
      <Box maxW="300px">
        <Text as="h1" fontSize="1.5rem" mb={2}>
          {pedido?.pedido}
        </Text>
        <Image
          src={pedido?.imagem_entrega}
          alt="Imagem do produto"
          w="300px"
          h="300px"
          objectFit="cover"
          borderRadius="md"
        />
        <Flex flexDirection={'column'} mt={2} gap={2}>
          {/* <Button colorScheme="blue" w="full" as="a" href={pedido?.imagem_produto}>
            Visualizar Nota
          </Button> */}
          <ModalVisualizarCanhoto canhotoUrl={pedido?.imagem_entrega} />
        </Flex>
      </Box>
      <TableContainer mt="2rem">
        <Table variant="simple">
          <TableCaption>Informações sobre o pedido</TableCaption>
          <Thead>
            <Tr>
              <Th textAlign={'center'}>Pedido</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td textAlign={'center'}>{pedido?.pedido}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
